//
// Sidebox fixed
//
var fn_sharingtools_fixed = function () {

    var asideElt = $('.js-social-bar');

    function fn_sharingtools_rwd() {

        var asideDelimiter = $('.main'),
            initialTopAsideDelimiter = asideElt.position().top,
            initialTopAsideCSSValue = 'calc(50% - (28rem / 2))';

        var screensize = window.innerWidth;

        if (screensize <= 1279) {
            // //
            // RWD Below 1280px - Social Bar is inline on Right side or Centered
            asideElt.css('top', '').css('position', 'static');
            // //
        } else {
            // //
            // RWD Min 1280px - Social bar is Fixed and avoids the Footer-wrapper
            function fn_sidebox_scroll() {

                // Limits for sticky
                var beginStickyPosition = asideElt.offset().top + asideElt.outerHeight() * 0.5 - $(window).outerHeight() * 0.5;
                var endStickyPosition = asideDelimiter.offset().top + asideDelimiter.outerHeight();

                var scrollTopPosition = $(this).scrollTop();
                var stickyBottomPosition = scrollTopPosition + asideElt.outerHeight() * 0.5 + $(window).outerHeight() * 0.5;

                //
                // Sticky
                //
                if (scrollTopPosition >= beginStickyPosition && stickyBottomPosition < endStickyPosition) {
                    asideElt.css('top', initialTopAsideCSSValue).css('position', 'fixed');

                } else if (stickyBottomPosition >= endStickyPosition) {
                    asideElt.css('top', ((endStickyPosition - scrollTopPosition - asideElt.outerHeight()) / 10 + 'rem')).css('position', 'fixed');

                } else {
                    // inital position
                    asideElt.css('top', initialTopAsideDelimiter / 10 + 'rem').css('position', 'fixed');
                }

            }
            fn_sidebox_scroll()
            // //
        }

    }

    if ($(asideElt).length) {
        // do stuff when selector exists
        $(window).on('load scroll resize orientationchange', function () {
            fn_sharingtools_rwd();
        });

    }

};

